import App from './App.vue';
import ErrorPage from './views/ErrorPage.vue';
import router from './router';
import store from './store';
import Vue from 'vue';
import {jwtDecode} from "jwt-decode";

/** Import Style von PrimeVue **/
import './assets/layout/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

/** Import Selfmade Styles **/
import './assets/layout/layout.scss';

/** Import PrimeVue Components **/
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import ContextMenu from 'primevue/contextmenu';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import DropDown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from "primevue/inputnumber";
import Listbox from 'primevue/listbox';
import Menu from 'primevue/menu';
import MultiSelect from 'primevue/multiselect';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import RadioButton from 'primevue/radiobutton';
import Steps from 'primevue/steps';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Tree from 'primevue/tree';
import ValidationMessage from 'primevue/validationmessage'
import Vuelidate from 'vuelidate';
/**
 * Vue Js Logger
 */
import VueLogger from 'vuejs-logger';
import axios from 'axios';
import Keycloak from "keycloak-js";

Vue.use(Vuelidate);
Vue.use(ToastService);
Vue.use(require('vue-shortkey'));

/** Register PrimeVue Components **/
Vue.component('Button', Button);
Vue.component('Calendar', Calendar)
Vue.component('Card', Card);
Vue.component('Checkbox', Checkbox);
Vue.component('ContextMenu', ContextMenu);
Vue.component('Column', Column);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('DataTable', DataTable);
Vue.component('Dialog', Dialog);
Vue.component('DropDown', DropDown);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component('Listbox', Listbox);
Vue.component("Menu", Menu)
Vue.component('MultiSelect', MultiSelect);
Vue.component('Password', Password);
Vue.component('PanelMenu', PanelMenu);
Vue.component("PickList", PickList);
Vue.component('RadioButton', RadioButton);
Vue.component('Steps', Steps);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('Toast', Toast);
Vue.component('Tree', Tree);
Vue.component('ValidationMessage', ValidationMessage);

Vue.config.productionTip = false

const isProduction = process.env.NODE_ENV === 'production';
const options = {
  isEnabled: !isProduction,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);

/**
 * Load the Application Configuration
 * enable/disable Keycloak
 */

console.info("Application Starting");

// axios.get('/api/avail/config').then((configuration) => {
axios.get('/api/public/config').then((configuration) => {

  console.log("Configuration", configuration);

  if (configuration.data.authType === "KEYCLOAK") {

    let keycloakConfig = {
      url: configuration.data.keycloak.authServerUrl,
      realm: configuration.data.keycloak.realm,
      clientId: configuration.data.keycloak.resource,
      onLoad: 'login-required'
    }

    let initOptions = {
      onLoad: 'login-required'
    }

    if (localStorage.getItem("token")) {

      // check if the token is valid
      try {
        let token = localStorage.getItem("token");
        let decodedToken = jwtDecode(token);
        if (decodedToken.exp > new Date().getTime()) {
          // if the token is not expired we use it
          decodedToken.initOptions['token'] = localStorage.getItem("token");
          initOptions['idToken'] = localStorage.getItem("idToken");
          initOptions['refreshToken'] = localStorage.getItem("refreshToken");
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("idToken");
          localStorage.removeItem("refreshToken");
        }
      } catch (e) {
        // just ignore and proceed with normal login
      }
    }


    let keycloak = Keycloak(keycloakConfig);

    keycloak.init(initOptions).then((auth) => {
      if (!auth) {
        window.location.reload();
      } else {
        console.debug("Authenticated");

        new Vue({
          store,
          router,
          render: h => h(App, {props: {keycloak: keycloak}})
        }).$mount('#app')
      }

      //Token Refresh
      setInterval(() => {
        keycloak.updateToken(70).then((refreshed) => {
          if (refreshed) {
            console.debug('Token refreshed' + refreshed);
            localStorage.setItem('token', keycloak.token);
            localStorage.setItem('idToken', keycloak.idToken);
            localStorage.setItem('refreshToken', keycloak.refreshToken);
          } else {
            console.debug('Token not refreshed, valid for '
              + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        }).catch(() => {
          console.error('Failed to refresh token');
        });
      }, 6000)

    }).catch(() => {
      console.error("Authenticated Failed");
    });

  } else {

    if (configuration.data.userInfo.loggedIn) {
      console.log("User is logged in!!!");
      store.commit('auth/setAuth', {
        isAuthenticated: configuration.data.userInfo.loggedIn,
        username: configuration.data.userInfo.username
      })
      store.dispatch("config/loadConfiguration").then(() => {
        new Vue({
          store,
          router,
          render: h => h(App, {props: {keycloak: null}})
        }).$mount('#app')

      });
    } else {
      store.dispatch("config/loadPublicConfiguration").then(() => {
        new Vue({
          store,
          router,
          render: h => h(App, {props: {keycloak: null}})
        }).$mount('#app')

      });
      // new Vue({
      //   store,
      //   router,
      //   render: h => h(App, {props: {keycloak: null}})
      // }).$mount('#app')
    }
  }

}).catch(() => {
  new Vue({
    render: h => h(ErrorPage)
  }).$mount('#app')
})


